export const METHODS = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  PUT: 'PUT'
};

export const SYSTEM_OWNER = 'env0-system';
export const ENV0_AVATAR = '/logo-no-text.png';
